import { render, staticRenderFns } from "./ItemVedett7m.vue?vue&type=template&id=b13797ac&scoped=true&"
import script from "./ItemVedett7m.vue?vue&type=script&lang=js&"
export * from "./ItemVedett7m.vue?vue&type=script&lang=js&"
import style0 from "./ItemVedett7m.vue?vue&type=style&index=0&id=b13797ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13797ac",
  null
  
)

export default component.exports